import { render } from "./whiteList_ip.vue?vue&type=template&id=3b50bf8c&scoped=true"
import script from "./whiteList_ip.vue?vue&type=script&lang=js"
export * from "./whiteList_ip.vue?vue&type=script&lang=js"

import "./whiteList_ip.vue?vue&type=style&index=0&id=3b50bf8c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b50bf8c"]])

export default __exports__